
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.64 13.64h-3.28V27h3.28V13.64zm-3.28 16.72h3.28v3.28h-3.28v-3.28zM27 25.827v4.531a16.678 16.678 0 01-4.688 2.422c-1.666.573-3.437.86-5.312.86-2.292 0-4.453-.417-6.484-1.25a18.397 18.397 0 01-5.313-3.594 18.397 18.397 0 01-3.594-5.313C.776 21.454.36 19.292.36 17s.417-4.427 1.25-6.406c.886-2.031 2.084-3.802 3.594-5.313a16.531 16.531 0 015.313-3.593C12.546.801 14.708.359 17 .359c2.5 0 4.844.521 7.031 1.563 2.188 1.042 4.037 2.422 5.547 4.14L17 18.642v-15c-1.823 0-3.542.364-5.156 1.093a13.296 13.296 0 00-4.297 2.891 14.126 14.126 0 00-2.89 4.219C3.978 13.458 3.64 15.177 3.64 17c0 1.823.338 3.542 1.015 5.156a15.2 15.2 0 002.89 4.297 15.201 15.201 0 004.298 2.89c1.614.678 3.333 1.016 5.156 1.016 1.98 0 3.828-.416 5.547-1.25A14.756 14.756 0 0027 25.83z"}})])
          )
        }
      }
    